import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter
} from '@/components/ui/dialog';
import { Building2, Loader2 } from 'lucide-react';

/**
 * Modal for adding a new customer inline
 * Used by ExportsDashboard and ImportsDashboard
 */
export default function AddCustomerModal({
  open,
  onOpenChange,
  customerName,
  onCustomerNameChange,
  onSubmit,
  processing
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800 text-white max-w-md" data-testid="add-customer-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Building2 className="h-5 w-5 text-blue-400" />
            Add New Customer
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Create a new customer to assign to this shipment
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Customer Name *</Label>
            <Input
              value={customerName}
              onChange={(e) => onCustomerNameChange(e.target.value)}
              className="bg-slate-950 border-slate-800"
              placeholder="Enter customer name"
              data-testid="new-customer-name-input"
            />
          </div>
        </div>

        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => {
              onOpenChange(false);
              onCustomerNameChange('');
            }}
            className="border-slate-700"
          >
            Cancel
          </Button>
          <Button 
            onClick={onSubmit}
            disabled={processing || !customerName.trim()}
            className="bg-blue-600 hover:bg-blue-500"
            data-testid="add-customer-submit"
          >
            {processing ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
            Add Customer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
